import { render, staticRenderFns } from "./QuestionColorIcon.vue?vue&type=template&id=5e2ed688&"
import script from "./QuestionColorIcon.vue?vue&type=script&lang=js&"
export * from "./QuestionColorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports